class CashbackMessage extends HTMLElement {
  modalId = null
  constructor() {
    super()
    this.modalIdMobile = this.dataset.modalIdMobile
    this.modalIdDesktop = this.dataset.modalIdDesktop
    this.insiderCashbackPercentage = this.dataset.insiderCashbackPercentage
    this.cashbackAmount = this.dataset.cashbackAmount
    this.countryCode = this.dataset.countryCode
  }

  connectedCallback() {
    this.checkIfAlreadySubscribed()
  }

  checkIfAlreadySubscribed() {
    let attempts = 0
    const checkInterval = setInterval(() => {
      attempts++
      if (localStorage.getItem('rivo_cashback_profile')) {
        clearInterval(checkInterval)
        if (this.countryCode === 'US') {
          this.innerHTML = `<span>💵 You'll earn ${this.cashbackAmount} in store credit</span>`
        } else {
          this.innerHTML = `<span>💵 You'll earn ${this.insiderCashbackPercentage}% in store credit</span>`
        }
        this.classList.remove('loading')
      } else if (attempts > 10) {
        clearInterval(checkInterval)
        this.classList.remove('loading')
      }
    }, 200) // Check every 200ms
  }

  openModal() {
    if (window.innerWidth < 768) {
      console.log('======openModal=======')
      window._recart.showOptinTool(this.modalIdMobile, { force: true })
      console.log('======openModal Mobile=======', this.modalIdMobile)
    } else {
      window._recart.showOptinTool(this.modalIdDesktop, { force: true })
      console.log('======openModal Desktop=======', this.modalIdDesktop)
    }
  }
}
customElements.define('cashback-message', CashbackMessage)

// Check if the customer is already subscribed and show the cashback message in the cart drawer footer
function checkRivoCashbackProfile() {
  const cartDrawerFooterCashbackRow = document.querySelector('.js-store-credit-row')
  if (!cartDrawerFooterCashbackRow) return
  let attempts = 0
  const checkInterval = setInterval(() => {
    attempts++
    if (localStorage.getItem('rivo_cashback_profile')) {
      clearInterval(checkInterval)
      cartDrawerFooterCashbackRow.style.display = 'table-row'
    } else if (attempts > 10) {
      clearInterval(checkInterval)
    }
  }, 200) // Check every 200ms
}
document.addEventListener('DOMContentLoaded', () => {
  checkRivoCashbackProfile()
})
document.addEventListener('rivo-accounts:shopify:login', () => {
  const productInfo = document.querySelector('product-info')
  if (!productInfo) return
  const productHandle = productInfo.dataset.productHandle
  if (!productHandle) return
  productInfo.changeFullSection(productHandle, false)
})
